module.exports = __webpack_public_path__ + "img/hr-construction-robot-shadow.8a87995e.png";